import * as Yup from 'yup'

export const HobbiesValidationSchema = Yup.object().shape({
  hobbies: Yup.array().of(Yup.string()).required('Se requiere Hobbies'),
})